import { withSvgIcon } from './withSvgIcon';

export const FilterNewIcon = withSvgIcon(
  <>
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="#82899A"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path
      d="M8 9H16M11.2653 16H12.5714M9.71429 12.5H14.2857"
      stroke="#82899A"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
